import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getFilteredTransports, moveMapToTransport } from '../../../store/filterSlice'
import { showPopup, showTrack } from '../../../store/mapSlice'
import { getConfighideTrackButtons } from '../../../store/configSlice'
import iconDown from '../down-arrow.svg'

import { Transport } from './Transport'
import styles from './Transports.module.scss'

function TransportsBody({ transports, moveMapToTransport, showPopup, showTrack,hideTrackButtons }) {
    const [maxCount, setMaxCount] = useState(50)

    const showMore = useCallback(() => {
        setMaxCount(maxCount + 50)
    }, [maxCount, setMaxCount])

    return (
        <>
            {
                transports
                    .filter((item, i) => i < maxCount)
                    .filter((item) => item.atGarage === false)
                    .map(({ id, iconUrl, number, type }) => (
                        <Transport
                            key={id}
                            id={id}
                            iconUrl={iconUrl}
                            number={number}
                            type={type}
                            moveMapToTransport={moveMapToTransport}
                            showPopup={showPopup}
                            showTrack={showTrack}
                            hideTrackButtons={hideTrackButtons}
                        />
                    ))
            }
            {
                (maxCount < transports.length)
                    ? (
                        <button type="button" onClick={showMore} className={styles.showMore}>
                            Показать еще
                            <img src={iconDown} alt="Показать еще" />
                        </button>
                    )
                    : null
            }

        </>
    )
}

TransportsBody.propTypes = {
    transports: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            number: PropTypes.string.isRequired,
            time: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired,
            lat: PropTypes.number.isRequired,
            speed: PropTypes.number.isRequired,
            company: PropTypes.string.isRequired,
            iconUrl: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
        }),
    ).isRequired,
    moveMapToTransport: PropTypes.func.isRequired,
    showPopup: PropTypes.func.isRequired,
    showTrack: PropTypes.func.isRequired,
    hideTrackButtons: PropTypes.bool
}

const Transports = connect(
    state => ({
        transports: getFilteredTransports(state),
        hideTrackButtons: getConfighideTrackButtons(state)
    }), {
        moveMapToTransport,
        showPopup,
        showTrack,
    },
)(TransportsBody)

Transports.propTypes = {}

export { Transports }
